let nextPageID;
let secondNextPageID;
let questionsData = [];
let loading = false;

function nextPage(currentPage = false) {

  if (currentPage && !nextPageID) {
    nextPageID = +currentPage + 1
    secondNextPageID = +currentPage + 2
  }

  else if (nextPageID) {
    currentPage = nextPageID;
    nextPageID += 1;
    secondNextPageID = +nextPageID + 2
  }

  const currentElement = document.querySelector('.scenario__item[data-step="' + currentPage + '"]');
  const nextElement = document.querySelector('.scenario__item[data-step="' + nextPageID + '"]');
  const body = document.querySelector('body');
  currentElement.classList.add('scenario__item--pass');
  currentElement.classList.remove('scenario__item--current');
  nextElement.classList.add('scenario__item--current');
  nextElement.classList.remove('scenario__item--next');
  const transformX = currentPage * 100;

  document.querySelector(".scenario").style.transform = "translateX(-" + transformX + "vw)";

  if (currentElement.dataset.type === 'vote') {
    const input = currentElement.querySelector('.vote_team');

    if (input) {
      questionsData.push({
        who: body.dataset.lname,
        question: input.name,
        answere: input.value,
      })
    }
  }

  if (currentElement.dataset.type === 'question') {
    const input = currentElement.querySelector('input[type="radio"]:checked');

    if (input) {
      questionsData.push({
        who: body.dataset.lname,
        question: input.name,
        answere: input.value,
      })
    }
    else {
      questionsData.push({
        who: body.dataset.lname,
        question: '',
        answere: '',
      })
    }
  }

  if (nextElement.dataset.type === 'end') {
    saveData(questionsData, body.dataset.team, body.dataset.title);
  }

  if (nextElement.dataset.type === 'endVote') {
    saveVote(questionsData, body.dataset.team);
  }

  if (nextElement.dataset.type === 'question') {
    setupQuerstion(nextElement);
  }

  if (nextElement.dataset.type === 'vote') {
    setupVote(nextElement);
  }

}

function saveData(questionsData, team, titleRound) {
  const data = new FormData();
  const tmp = JSON.stringify(questionsData)
  data.append('questionsData', tmp);
  data.append('titleRound', titleRound);
  data.append('team', team);
  data.append('action', 'msm_questions');

  loading = true;
  if (!loading) {

  }
  fetch(my_ajax_object.ajaxurl, {
    method: 'post',
    body: data,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      console.log(json)
    });
}

function saveVote(questionsData, team) {
  const data = new FormData();
  const tmp = JSON.stringify(questionsData)
  data.append('questionsData', tmp);
  data.append('team', team);
  data.append('action', 'msm_vote');

  loading = true;
  if (!loading) {

  }
  fetch(my_ajax_object.ajaxurl, {
    method: 'post',
    body: data,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      console.log(json)
    });
}